import { forwardRef, memo } from "react";

import { Anchor } from "@newsela/angelou";
import PropTypes from "prop-types";

import {
  navItem,
  navItemActive,
  navItemLink,
  navList,
  navSpacer,
  newNavContainer,
} from "./SideNav.style";

const propTypes = {
  activeItemIndex: PropTypes.number,
  members: PropTypes.arrayOf(
    PropTypes.shape({
      content_id: PropTypes.string,
      content_type: PropTypes.string,
      date_published: PropTypes.string,
      member_count: PropTypes.number,
      slug: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  onSlugChange: PropTypes.func.isRequired,
};

const SideNav = forwardRef(
  ({ activeItemIndex, members, onSlugChange }, ref) => {
    const activeIndex = activeItemIndex || 0;
    const navItems =
      Array.isArray(members) &&
      members.map((item, idx) => {
        const navItemStyles = [navItem];
        let activeItemRef;
        let isCurrent = false;
        if (idx === activeIndex) {
          navItemStyles.push(navItemActive);
          activeItemRef = ref;
          isCurrent = true;
        }
        return (
          <li ref={activeItemRef} key={item.content_id} css={navItemStyles}>
            <Anchor
              href={`#${item.slug}`}
              __cssFor={{
                root: navItemLink,
              }}
              ariaProps={{
                "aria-current": isCurrent,
                "aria-label": item.title,
              }}
              onClick={() => onSlugChange(item.slug, idx)}
            >
              {item.title}
            </Anchor>
          </li>
        );
      });

    return (
      <>
        <nav aria-label="Browse page sections" css={newNavContainer}>
          <ol css={navList}>{navItems}</ol>
        </nav>
        <div css={navSpacer} />
      </>
    );
  },
);

SideNav.propTypes = propTypes;

export default memo(SideNav);
